import React from 'react';
import { isEmpty } from 'lodash';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import ServiceContainer from 'src/ServiceContainer';
import { addCrumb, type AddBreadcrumbPayload } from 'src/state/breadcrumbs/Bread.slice';
import { runLinkAction } from './LinkConfirmationModal.utils';
import { ClientDataApi } from 'configuration-schemas/confdefnView';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

export interface LinkConfirmationModalProps {
  isOpen: boolean;
  descriptionText: string;
  dataApi: ClientDataApi;
  breadcrumb?: string;
  getSelectedItems: () => unknown[];
  onClose: () => void;
  onAfterSuccess?: () => void;
}

export const LinkConfirmationModal: React.FC<LinkConfirmationModalProps> = (props) => {
  const { isOpen, descriptionText, dataApi, breadcrumb, getSelectedItems, onClose, onAfterSuccess } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const onAddCrumb = (payload: AddBreadcrumbPayload) => dispatch(addCrumb(payload));

  return (
    <ConfirmationModal
      isOpen={isOpen}
      isLoading={isLoading}
      descriptionText={descriptionText}
      onConfirm={() => {
        setIsLoading(true);
        try {
          const selectedItems = getSelectedItems();
          if (isEmpty(selectedItems)) {
            return;
          }

          runLinkAction({
            dataApi,
            breadcrumb,
            selectedItems,
            routerNavigate: navigate,
            addCrumb: onAddCrumb,
          });

          onAfterSuccess?.();
          onClose();
        } catch (e) {
          ServiceContainer.loggingService.error('Failed To link via button (modal wrapper)', (e as Error).stack);
        } finally {
          setIsLoading(false);
        }
      }}
      onCancel={() => {
        onClose();
      }}
    />
  );
};
